import { Component } from '@angular/core';

@Component({
  selector: 'app-billing-virtual-purchase',
  templateUrl: './billing-virtual-purchase.component.html',
  styleUrls: ['./billing-virtual-purchase.component.css']
})
export class BillingVirtualPurchaseComponent {

}
